module.exports = __webpack_public_path__ + "media/flags/li-65496806.svg";